import { AuthenticationError } from './AuthenticationError';

export class ForbiddenError extends AuthenticationError {
	constructor(message: string, cause?: Error) {
		super('ERROR_FORBIDDEN', message, cause);
	}
}
